var map = {
	"./arrow-left.svg": "xkKn",
	"./arrow-right.svg": "NLhE",
	"./confirmed.svg": "DFdS",
	"./dislike.svg": "enOV",
	"./ico-fb.svg": "Z5h4",
	"./ico-instagram.svg": "C6cs",
	"./ico-yt.svg": "33ue",
	"./icoX.svg": "XXeK",
	"./like.svg": "2Dax",
	"./loop.svg": "sfGt",
	"./pagination-next.svg": "UwsT",
	"./pagination-previous.svg": "oTWN",
	"./progress.svg": "4etv",
	"./star-gold.svg": "jcEY",
	"./star-silver.svg": "L98g"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "+tsz";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons-svg \.svg$
// module id = +tsz
// module chunks = 4